import { StyledDateSegment } from "./date-segment.style";
import { IMDSDateSegmentProps } from "./date-segment.types";

export function MDSDateSegment(props: IMDSDateSegmentProps) {
  return <StyledDateSegment {...props} />;
}
